import { render } from "./sdg-starting-page.vue?vue&type=template&id=7eea65b4&scoped=true&ts=true"
import script from "./sdg-starting-page.vue?vue&type=script&lang=ts"
export * from "./sdg-starting-page.vue?vue&type=script&lang=ts"

import "./sdg-starting-page.vue?vue&type=style&index=0&id=7eea65b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eea65b4"]])

export default __exports__